import {openConfirmModal} from './ConfirmModal';

export const confirmHtmxAction = (element) => {
    openConfirmModal(element, () => element.dispatchEvent(new CustomEvent('confirmed', {bubbles: true})));
};
